module.exports = __webpack_public_path__ + "img/level-2.c19586e0.svg";